import React from "react";
import { Navigate, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Users, FileText, FileType, Inbox } from "lucide-react";

export default function AdminLayout() {
  const { user, authHydrated } = useAuth();

  if (!authHydrated) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  const isAdmin = user?.roles?.includes("ROLE_ADMIN");
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
      isActive ? "bg-gray-900 text-white" : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
    }`;

  return (
    <div className="w-full">
      <div className="border-b border-gray-200 bg-white">
        <div className="max-w-300 mx-auto px-4">
          <nav className="flex gap-2 py-3">
            <NavLink to="/admin/users" className={linkClass}>
              <Users className="size-4" />
              Users
            </NavLink>
            <NavLink to="/admin/applications" className={linkClass}>
              <FileText className="size-4" />
              Applications
            </NavLink>
            <NavLink to="/admin/enquiries" className={linkClass}>
              <Inbox className="size-4" />
              Enquiries
            </NavLink>
            <NavLink to="/admin/document-types" className={linkClass}>
              <FileType className="size-4" />
              Document Types
            </NavLink>
          </nav>
        </div>
      </div>
      <div className="max-w-300 mx-auto px-4 py-6">
        <Outlet />
      </div>
    </div>
  );
}
